import { Product } from '../types/store'

export const mockProducts: Product[] = [
  {
    id: 'prod_1',
    name: 'Performance T-Shirt',
    description:
      'Moisture-wicking performance tee with team logo. Perfect for practice and game day.',
    variants: [
      {
        id: 'var_1',
        name: 'Youth Small / Navy',
        sku: 'TEE-YS-NAV',
        price: 24.99,
      },
      {
        id: 'var_2',
        name: 'Youth Medium / Navy',
        sku: 'TEE-YM-NAV',
        price: 24.99,
      },
      {
        id: 'var_3',
        name: 'Youth Large / Navy',
        sku: 'TEE-YL-NAV',
        price: 24.99,
      },
      {
        id: 'var_4',
        name: 'Adult Small / Navy',
        sku: 'TEE-AS-NAV',
        price: 29.99,
      },
      {
        id: 'var_5',
        name: 'Adult Medium / Navy',
        sku: 'TEE-AM-NAV',
        price: 29.99,
      },
      {
        id: 'var_6',
        name: 'Adult Large / Navy',
        sku: 'TEE-AL-NAV',
        price: 29.99,
      },
      {
        id: 'var_7',
        name: 'Adult XL / Navy',
        sku: 'TEE-AXL-NAV',
        price: 29.99,
      },
    ],
    decorationMethod: 'print',
    decorationLocations: ['Front', 'Back'],
    designArtUrl: '/placeholder-tshirt.jpg',
    personalizationFields: [
      {
        id: 'pf_1',
        label: 'Player Name',
        type: 'text',
        required: true,
        characterLimit: 20,
        allowedCharacters: 'Letters only',
      },
      {
        id: 'pf_2',
        label: 'Jersey Number',
        type: 'number',
        required: true,
        characterLimit: 2,
      },
    ],
  },
  {
    id: 'prod_2',
    name: 'Team Hoodie',
    description:
      'Heavyweight fleece hoodie with embroidered team logo. Stay warm in style.',
    variants: [
      {
        id: 'var_8',
        name: 'Youth Small / Gray',
        sku: 'HOOD-YS-GRY',
        price: 44.99,
      },
      {
        id: 'var_9',
        name: 'Youth Medium / Gray',
        sku: 'HOOD-YM-GRY',
        price: 44.99,
      },
      {
        id: 'var_10',
        name: 'Youth Large / Gray',
        sku: 'HOOD-YL-GRY',
        price: 44.99,
      },
      {
        id: 'var_11',
        name: 'Adult Small / Gray',
        sku: 'HOOD-AS-GRY',
        price: 54.99,
      },
      {
        id: 'var_12',
        name: 'Adult Medium / Gray',
        sku: 'HOOD-AM-GRY',
        price: 54.99,
      },
      {
        id: 'var_13',
        name: 'Adult Large / Gray',
        sku: 'HOOD-AL-GRY',
        price: 54.99,
      },
      {
        id: 'var_14',
        name: 'Adult XL / Gray',
        sku: 'HOOD-AXL-GRY',
        price: 54.99,
      },
    ],
    decorationMethod: 'embroidery',
    decorationLocations: ['Left Chest'],
    designArtUrl: '/placeholder-hoodie.jpg',
    personalizationFields: [],
  },
  {
    id: 'prod_3',
    name: 'Team Cap',
    description:
      'Adjustable snapback cap with embroidered logo. One size fits most.',
    variants: [
      {
        id: 'var_15',
        name: 'One Size / Navy',
        sku: 'CAP-OS-NAV',
        price: 19.99,
      },
      {
        id: 'var_16',
        name: 'One Size / Gray',
        sku: 'CAP-OS-GRY',
        price: 19.99,
      },
    ],
    decorationMethod: 'embroidery',
    decorationLocations: ['Front'],
    designArtUrl: '/placeholder-cap.jpg',
    personalizationFields: [],
  },
  {
    id: 'prod_4',
    name: 'Gear Bag',
    description:
      'Durable duffel bag with team logo. Perfect for carrying all your equipment.',
    variants: [
      {
        id: 'var_17',
        name: 'Standard / Navy',
        sku: 'BAG-STD-NAV',
        price: 39.99,
      },
    ],
    decorationMethod: 'print',
    decorationLocations: ['Side Panel'],
    designArtUrl: '/placeholder-bag.jpg',
    personalizationFields: [
      {
        id: 'pf_3',
        label: 'Player Name (Optional)',
        type: 'text',
        required: false,
        characterLimit: 20,
      },
    ],
  },
  {
    id: 'prod_5',
    name: 'Player Pack Bundle',
    description:
      'Complete player package: Performance Tee + Hoodie + Cap. Save $10!',
    variants: [
      {
        id: 'var_18',
        name: 'Youth Small Bundle',
        sku: 'BUNDLE-YS',
        price: 79.99,
      },
      {
        id: 'var_19',
        name: 'Youth Medium Bundle',
        sku: 'BUNDLE-YM',
        price: 79.99,
      },
      {
        id: 'var_20',
        name: 'Youth Large Bundle',
        sku: 'BUNDLE-YL',
        price: 79.99,
      },
      {
        id: 'var_21',
        name: 'Adult Small Bundle',
        sku: 'BUNDLE-AS',
        price: 94.99,
      },
      {
        id: 'var_22',
        name: 'Adult Medium Bundle',
        sku: 'BUNDLE-AM',
        price: 94.99,
      },
      {
        id: 'var_23',
        name: 'Adult Large Bundle',
        sku: 'BUNDLE-AL',
        price: 94.99,
      },
      {
        id: 'var_24',
        name: 'Adult XL Bundle',
        sku: 'BUNDLE-AXL',
        price: 94.99,
      },
    ],
    decorationMethod: 'print',
    decorationLocations: ['Multiple'],
    designArtUrl: '/placeholder-bundle.jpg',
    personalizationFields: [
      {
        id: 'pf_4',
        label: 'Player Name',
        type: 'text',
        required: true,
        characterLimit: 20,
      },
      {
        id: 'pf_5',
        label: 'Jersey Number',
        type: 'number',
        required: true,
        characterLimit: 2,
      },
    ],
  },
]

// Update mock stores with products
export function getStoreWithProducts(storeId: string) {
  // In a real app, this would filter products by store
  // For demo, all stores get all products
  return mockProducts
}
